import { render, staticRenderFns } from "./OrderBinPopup.vue?vue&type=template&id=72981608&scoped=true"
import script from "./OrderBinPopup.vue?vue&type=script&lang=js"
export * from "./OrderBinPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72981608",
  null
  
)

export default component.exports